import React, { useEffect, useState } from 'react';
import Main from '../Main';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchUserDetails,
  resetPassword,
  updateUserDetails,
} from '../../../Redux/UserRedux.js';
import toast from 'react-hot-toast';

function AccountDetails() {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('user'));
  const { userDetails } = useSelector((state) => state.userRedux);
  const [isChecked, setIsChecked] = useState(false);
  const [isChanged, setIsChanged] = useState(false);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    displayName: '',
    emailId: '',
    DOB: { day: '', month: '', year: '' },
    gender: '',
    phoneNumber: '',
  });

  useEffect(() => {
    dispatch(fetchUserDetails(user.userId));
  }, [dispatch, user.userId]);

  useEffect(() => {
    if (userDetails) {
      const [day, month, year] = userDetails.DOB
        ? userDetails.DOB.split('-')
        : ['', '', ''];
      setFormData({
        firstName: userDetails.firstName,
        lastName: userDetails.lastName,
        displayName: userDetails.displayName,
        emailId: userDetails.emailId,
        DOB: { day, month, year },
        gender: userDetails.gender,
        phoneNumber: userDetails.phoneNumber,
      });
    }
  }, [userDetails]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
    setIsChanged(true);
  };
  const handleSelectChange = (e) => {
    setFormData({
      ...formData,
      gender: e.target.value,
    });
    setIsChanged(true);
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      DOB: {
        ...formData.DOB,
        [name]: value,
      },
    });
    setIsChanged(true);
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
    setFormData((prevFormData) => ({
      ...prevFormData,
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
    }));
  };

  const handleSave = (e) => {
    e.preventDefault();
    const updatedData = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      displayName: formData.displayName,
      emailId: formData.emailId,
      DOB: `${formData.DOB.day}-${formData.DOB.month}-${formData.DOB.year}`,
      gender: formData.gender,
      phoneNumber: formData.phoneNumber,
    };
    if (isChecked) {
      const resetPasswordData = {
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword,
        confirmPassword: formData.confirmPassword,
      };
      if (
        !resetPasswordData.currentPassword ||
        !resetPasswordData.newPassword ||
        !resetPasswordData.confirmPassword
      ) {
        toast.error(
          'Please fill in all password fields to reset the password.'
        );
        return;
      }
      // dispatch(updateUserDetails(user.userId, updatedData));
      dispatch(resetPassword(user.userId, resetPasswordData));
      setFormData((prevFormData) => ({
        ...prevFormData,
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      }));
    } else {
      dispatch(updateUserDetails(user.userId, updatedData));
    }
    setIsChanged(false);
  };

  return (
    <Main>
      <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
        <div
          className='container border p-5'
          style={{
            boxShadow: '0px 4px 8px 5px rgba(0, 0, 0, 0.1)',
          }}
        >
          <div className='row'>
            <div className='col-6'>
              <label htmlFor='firstName'>
                First Name <span className='requiredAsterisk'>*</span>
              </label>
              <input
                type='text'
                id='firstName'
                className='form-control mb-3'
                style={{ border: '1px solid #cccccc' }}
                value={formData.firstName}
                onChange={handleChange}
                disabled={isChecked}
              />
            </div>
            <div className='col-6'>
              <label htmlFor='lastName'>
                Last Name <span className='requiredAsterisk'>*</span>
              </label>
              <input
                type='text'
                id='lastName'
                className='form-control mb-3'
                style={{ border: '1px solid #cccccc' }}
                value={formData.lastName}
                onChange={handleChange}
                disabled={isChecked}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-6'>
              <label htmlFor='displayName'>
                Display Name <span className='requiredAsterisk'>*</span>
              </label>
              <div>
                <input
                  type='text'
                  id='displayName'
                  className='form-control'
                  style={{ border: '1px solid #cccccc' }}
                  value={formData.displayName}
                  onChange={handleChange}
                  disabled={isChecked}
                />
                <small
                  className='text-muted fst-italic'
                  style={{ fontSize: '10px' }}
                >
                  This will be how your name will be displayed in the account
                  section and in reviews
                </small>
              </div>
            </div>
            <div className='col-6'>
              <label htmlFor='registerEmail'>
                Email address <span className='requiredAsterisk'>*</span>
              </label>
              <input
                type='email'
                id='registerEmail'
                name='registerEmail'
                className='form-control mb-3'
                style={{ border: '1px solid #cccccc' }}
                value={formData.emailId}
                readOnly
                disabled={isChecked}
              />
            </div>
          </div>

          <div className='row'>
            <div className='col-4'>
              <label htmlFor='DOB'>
                Date of Birth <span className='requiredAsterisk'>*</span>
              </label>
              <div className='d-flex'>
                <input
                  type='text'
                  name='day'
                  className='form-control mb-3'
                  style={{
                    width: '30%',
                    marginRight: '5px',
                    border: '1px solid #cccccc',
                  }}
                  placeholder='DD'
                  value={formData.DOB.day}
                  onChange={handleDateChange}
                  maxLength={2}
                  onKeyPress={(e) => {
                    if (!/^[0-9]$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  disabled={isChecked}
                />
                <input
                  type='text'
                  name='month'
                  className='form-control mb-3'
                  style={{
                    width: '30%',
                    marginRight: '5px',
                    border: '1px solid #cccccc',
                  }}
                  placeholder='MM'
                  value={formData.DOB.month}
                  onChange={handleDateChange}
                  maxLength={2}
                  onKeyPress={(e) => {
                    if (!/^[0-9]$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  disabled={isChecked}
                />
                <input
                  type='text'
                  name='year'
                  className='form-control mb-3'
                  style={{ width: '40%', border: '1px solid #cccccc' }}
                  placeholder='YYYY'
                  value={formData.DOB.year}
                  onChange={handleDateChange}
                  maxLength={4}
                  onKeyPress={(e) => {
                    if (!/^[0-9]$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  disabled={isChecked}
                />
              </div>
            </div>
            <div className='col-4'>
              <label htmlFor='gender'>
                Gender <span className='requiredAsterisk'>*</span>
              </label>
              <select
                id='gender'
                className='form-control mb-3'
                style={{ border: '1px solid #cccccc' }}
                value={formData.gender}
                onChange={handleSelectChange}
                disabled={isChecked}
              >
                <option value='' disabled>
                  Select Gender
                </option>
                <option value='Male'>Male</option>
                <option value='Female'>Female</option>
              </select>
            </div>
            <div className='col-4'>
              <label htmlFor='phoneNumber'>
                Phone Number <span className='requiredAsterisk'>*</span>
              </label>
              <input
                type='text'
                id='phoneNumber'
                className='form-control mb-3'
                style={{ border: '1px solid #cccccc' }}
                value={formData.phoneNumber}
                onChange={handleChange}
                // maxLength={4}
                onKeyPress={(e) => {
                  if (!/^[0-9]$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                disabled={isChecked}
              />
            </div>
          </div>

          <div className='row mt-3'>
            <div className='col-12'>
              <h5 style={{ color: 'var(--primary-color)' }}>
                Do you want to change your password?
                {/* <small className='text-dark' style={{ fontSize: '13px' }}>
                  (leave blank to leave unchanged)
                </small> */}
              </h5>
              <div className='form-check'>
                <input
                  className='form-check-input is-valid'
                  type='checkbox'
                  id='changePasswordCheckbox'
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
                <label
                  className='form-check-label text-dark'
                  htmlFor='changePasswordCheckbox'
                  style={{ fontSize: '15px' }}
                >
                  Yes
                </label>
              </div>
            </div>
            {/* <div className='col-4 '>
              <ModeEditIcon />
            </div> */}
            <div className='col-12 mt-1'>
              <label htmlFor='currentPassword'>
                Current password
                <span className='requiredAsterisk'>*</span>
              </label>
              <input
                type='password'
                id='currentPassword'
                className='form-control mb-3'
                style={{ border: '1px solid #cccccc' }}
                value={formData.currentPassword}
                onChange={handleChange}
                disabled={!isChecked}
              />
            </div>
            <div className='col-12'>
              <label htmlFor='newPassword'>
                New password
                <span className='requiredAsterisk'>*</span>
              </label>
              <input
                type='password'
                id='newPassword'
                className='form-control mb-3'
                style={{ border: '1px solid #cccccc' }}
                value={formData.newPassword}
                onChange={handleChange}
                disabled={!isChecked}
              />
            </div>
            <div className='col-12'>
              <label htmlFor='confirmPassword'>
                Confirm new password
                <span className='requiredAsterisk'>*</span>
              </label>
              <input
                type='password'
                id='confirmPassword'
                className='form-control mb-3'
                style={{ border: '1px solid #cccccc' }}
                value={formData.confirmPassword}
                onChange={handleChange}
                disabled={!isChecked}
              />
            </div>
          </div>

          {/* <p style={{ textAlign: 'justify' }}>
          Your personal data will be used to support your experience throughout
          this website, to manage access to your account, and for other purposes
          described in our privacy policy.
        </p> */}
          <div className='row'>
            <div className='d-grid gap-2 col-8 mx-auto'>
              <button
                className='btn'
                style={{ background: '#2b6930', color: '#fff' }}
                type='button'
                disabled={!isChanged}
                onClick={handleSave}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </Box>
    </Main>
  );
}

export default AccountDetails;
